<template>
  <span>
    <v-list-item
      v-if="value > 1"
      class="list-toggler list-toggler-off hover-list-element text-body-2"
      @click="computedValue = computedValue - 1"
    >
      <v-list-item-content>
        <v-list-item-title class="list-toggler-text text-body-2">
          {{ toggleOffTitle }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      v-if="isNextVisible"
      class="list-toggler hover-list-element text-body-2"
      @click="computedValue = computedValue + 1"
    >
      <v-list-item-content>
        <v-list-item-title class="list-toggler-text text-body-2">
          {{ toggleOnTitle }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </span>
</template>
<script>
export default {
  name: 'ListToggler',
  props: {
    toggleOnStraightTitle: {
      type: String,
    },
    toggleOffStraightTitle: {
      type: String,
    },
    toggleOnTranslationPath: {
      type: String,
      default: 'featureCard.seeMore',
    },
    toggleOffTranslationPath: {
      type: String,
      default: 'featureCard.seeLess',
    },
    value: {
      type: Number,
      required: true,
    },
    allItemsLength: {
      type: Number,
    },
    pageItemsLength: {
      type: Number,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    isNextVisible() {
      return !this.allItemsLength || !this.pageItemsLength
        ? true
        : Math.round(this.allItemsLength / this.pageItemsLength) > this.computedValue;
    },
    toggleOnTitle() {
      return this.toggleOnStraightTitle || this.$i18n.t(this.toggleOnTranslationPath);
    },
    toggleOffTitle() {
      return this.toggleOffStraightTitle || this.$i18n.t(this.toggleOffTranslationPath);
    },
  },
};
</script>
<style lang="scss" scoped>
.list-toggler {
  min-height: 36px;
  max-height: 36px;
}
.list-toggler-off {
  @include border(bottom);
}
.list-toggler-text {
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.5) !important;
}
</style>
